export default __webpack_public_path__ + "static/media/employees.aaed2e4e.svg";